// export const apiserver = "http://localhost:3003";

export const apiserver = "https://api.sports.ixepa.com";
